import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]
  static values = { source: String }

  mount(event) {
    this.content = event.detail.content
    if (this.player) return

    const player = this.templateTarget.content.firstElementChild.cloneNode(true)
    const source = atob(this.sourceValue)

    player.dataset.videoPlayerSourceValue = source
    player.src = source
    this.content.replaceChildren(player)
  }

  get player() {
    return this.content?.querySelector("media-player")
  }
}
